import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  /** Person id from URL (`p=`) or prior session; persisted via redux-persist. */
  personId: '',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setPersonId(state, action) {
      const v = action.payload;
      state.personId = v != null ? String(v).trim() : '';
    },
    clearPersonId(state) {
      state.personId = '';
    },
  },
});

export const { setPersonId, clearPersonId } = userSlice.actions;

export function selectPersonId(state) {
  return state.user?.personId ?? '';
}

export default userSlice.reducer;
